module.exports = __webpack_public_path__ + "static/media/sapphire.9809416c.png";